import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiFaceSwap = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-face-swap',
			name: 'AI Face Swap | Swap faces between photos in seconds | Lift',
			description:
				'Swap faces between photos in seconds with AI Face Swap. No watermark. Create yours with Lift now.',
			url: 'https://liftapp.ai/ai-face-swap',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-face-swap#product' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#howto' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#benefits' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#faq' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-face-swap#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-face-swap#product',
			name: 'AI Face Swap',
			description:
				'Swap faces between photos in seconds with AI Face Swap. No watermark.',
			url: 'https://liftapp.ai/ai-face-swap',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-face-swap#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Watch the AI swap work its magic',
					text: 'Our AI detects faces with precision, matches lighting and angles, and blends them seamlessly — so your swaps look smooth, natural, and photorealistic',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-face-swap#benefits',
			name: 'Who can benefit from AI Face Swap?',
			description:
				'Create fun memes, unique social media content, and professional ads fast and without Photoshop skills',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI Face Swap is perfect for anyone who wants fun, realistic edits without heavy Photoshop skills',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Friends can create hilarious memes or swap faces for inside jokes',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators can generate viral, share-worthy posts with a unique twist',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Businesses and marketers can craft creative ads or social campaigns without costly photo shoots',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'This tool delivers fast, high-quality results — ideal for both entertainment and professional use',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.9359e979.webp',
				name: 'AI Face Swap expample',
				description:
					"An image demonstrating an AI face swap, showing a woman's face replaced with another.",
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-face-swap#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Face Swap?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Face Swap is a smart online tool that lets you replace faces between photos with natural, realistic results — great for memes, edits, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Face Swap work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI scans the source and target faces, matches facial features, lighting, and expressions, then blends them together automatically. No manual editing required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will the swap look realistic?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Face Swap uses advanced face-matching and blending technology to preserve skin tone, facial structure, and details — so the result looks smooth and believable.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-face-swap#why-lift',
			name: 'Why Lift’s AI Face Swap stands out',
			description:
				"Lift's AI Face Swap is a powerful and affordable tool that delivers professional, studio-quality results. Its smart AI ensures precise face swaps.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.126409a0.webp',
				name: "Lift's AI Face Swap Features",
				description:
					'A side-by-side image showing a man in a Superman costume with his face swapped.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-face-swap#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-face-swap#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Object Remover',
					item: 'https://liftapp.ai/ai-face-swap',
				},
			],
		},
	],
};
